import React from 'react';
import Loadable from '@caixue/react-loadable';
import { Loading } from 'components';

export default Loadable({
  loader: () => import('./index'),
  loading: () => <Loading withContentWrapper />,
});

export const AnalyticsPage = Loadable({
  loader: () => import('./AnalyticsPage'),
  loading: () => null,
});
